import React from 'react';
import { Section } from '../Section';
import { RouteFlow } from '../RouteFlow';
import { TransformCTA } from '../TransformCTA';
const limits = ['Not to replace clinical judgment.', 'Not to replace current guidelines.', 'Not to replace specialist consultation.'];
export function NextConsultation() {
  return <Section title="Your next renal consultation can have a route." subtitle="Instead of: search, cross-reference, second-guess — you can start with a structured pathway." data-id="element-214" data-mp="2yefnht0zpzz1">
      <RouteFlow steps={['Finding', 'Decision route', 'Assessment', 'Action', 'Monitoring', 'Follow-up / Referral']} data-id="element-215" data-mp="38aikylkwdafn" />

      <div className="mx-auto mt-9 max-w-2xl rounded-3xl border border-ink-line bg-white p-5 sm:p-7" data-id="element-216" data-mp="3i0bwxnoybrkf">
        <p className="text-[15px] font-semibold text-ink" data-id="element-217" data-mp="3m49w1yea12dh">
          That’s the purpose of Renal Decision Desk™.
        </p>
        <ul className="mt-3 space-y-1.5" data-id="element-218" data-mp="3r2bdkew20tmu">
          {limits.map(limit => <li key={limit} className="text-[14px] text-ink-soft" data-id="element-219" data-mp="1a77a5wiogkqx">
              {limit}
            </li>)}
        </ul>
        <p className="mt-4 text-[14.5px] leading-relaxed text-ink" data-id="element-220" data-mp="166x2mff8lm9y">
          But to give you a structured way to organize the information and
          questions that matter during the consultation.
        </p>
      </div>

      <TransformCTA label="Give my next consultation a route" sub="One-time $27 payment • Lifetime access" data-id="element-221" data-mp="1tu5bt8fsdfh9" />
    </Section>;
}